import { ApiServiceBase } from './base/api-service-base';
import { IApiService } from 'api/interfaces/api-service';
import { IAppConfigService } from 'api/interfaces/app-config-service';

const baseEndpoint = 'api/tracking';

export interface ITrackingApiService {
	TrackPageView(eventName: string, pageUrl: string, menuName: string, displayName?: string, eventTimeMs?: number, deviceId?: string): Promise<void>;
	TrackPowerBIEvent(eventName: string, pageUrl: string, menuName: string, displayName?: string, visualName?: string, visualType?: string, filterData?: string, selectionData?: string, eventTimeMs?: number, deviceId?: string): Promise<void>;
	TrackClick(elementName: string, elementId: string, pageUrl: string, deviceId?: string): Promise<void>;
}

export class TrackingApiService extends ApiServiceBase implements ITrackingApiService {
	constructor(
		apiService: IApiService,
		appConfigService: IAppConfigService
	) {
		super(apiService, appConfigService);
	}

	public async TrackPageView(eventName: string, pageUrl: string, menuName: string, displayName?: string, eventTimeMs?: number, deviceId?: string): Promise<void> {
		const payload: any = {
			eventName,
			pageUrl,
			menuName
		};
		
		if (displayName !== undefined && displayName !== null) {
			payload.displayName = displayName;
		}
		
		if (eventTimeMs !== undefined && eventTimeMs !== null) {
			payload.eventTimeMs = eventTimeMs;
		}
		
		if (deviceId !== undefined && deviceId !== null) {
			payload.deviceId = deviceId;
		}
		
		await this.PostToApi(`${baseEndpoint}/pageview`, payload);
	}

	public async TrackPowerBIEvent(eventName: string, pageUrl: string, menuName: string, displayName?: string, visualName?: string, visualType?: string, filterData?: string, selectionData?: string, eventTimeMs?: number, deviceId?: string): Promise<void> {
		const payload: any = {
			eventName,
			pageUrl,
			menuName
		};
		
		if (displayName !== undefined && displayName !== null) {
			payload.displayName = displayName;
		}
		
		if (visualName !== undefined && visualName !== null) {
			payload.visualName = visualName;
		}
		
		if (visualType !== undefined && visualType !== null) {
			payload.visualType = visualType;
		}
		
		if (filterData !== undefined && filterData !== null) {
			payload.filterData = filterData;
		}
		
		if (selectionData !== undefined && selectionData !== null) {
			payload.selectionData = selectionData;
		}
		
		if (eventTimeMs !== undefined && eventTimeMs !== null) {
			payload.eventTimeMs = eventTimeMs;
		}
		
		if (deviceId !== undefined && deviceId !== null) {
			payload.deviceId = deviceId;
		}
		
		await this.PostToApi(`${baseEndpoint}/pbievent`, payload);
	}

	public async TrackClick(elementName: string, elementId: string, pageUrl: string, deviceId?: string): Promise<void> {
		await this.PostToApi(`${baseEndpoint}/click`, {
			elementName,
			elementId,
			pageUrl,
			deviceId
		});
	}
}

